<template>
  <div class="justify-content-md-center" style="margin-top:5%;">
    <h1> Mise à jour de la <br> {{displayedName}} </h1>
    <b-card v-if="selectedLoop" style="margin-top:7%;">
        <b-row>
            <b-col sm="4">
                <h3> Informations générales </h3>
                <b-form @submit="onSubmit" @reset="onReset">
                    <b-form-group
                        id="loopName"
                        label="Nom"
                        label-for="loopInputName">
                        <b-form-input
                        id="loopInputName"
                        type="text"
                        v-model="loop_name"
                        required
                        placeholder="Entrez le nom"
                        />
                    </b-form-group>
                    <b-form-group
                        id="loopDescription"
                        label="Description"
                        label-for="loopDescription1">
                        <b-form-input
                        id="loopDescription1"
                        type="text"
                        v-model="loop_description"
                        required
                        placeholder="Entrez la description"
                        />
                    </b-form-group>
                    <b-button type="reset" variant="danger">Annuler</b-button>
                    <b-button type="submit" variant="primary">Mettre à jour</b-button>
                </b-form>
            </b-col>
            <b-col sm="8">
                <b-row>
                    <b-col sm="10"><h3> Stations de travail </h3></b-col>
                    <b-col sm="2"><b-button variant="primary" @click="showAddWorkstation()"><i class="fa fa-plus" aria-hidden="true"></i></b-button></b-col>
                </b-row>
                <b-table striped
                    hover
                    :items="workstations"
                    :fields="fields">
                        <template v-slot:cell(Update)="row">
                            <div>
                            <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                            <b-button
                                :disabled="!isAdmin"
                                size="sm"
                                variant="primary"
                                @click="showAddWorkstation(row.item)"
                                class="mr-2"
                            >
                                <i class="fa fa-refresh" aria-hidden="true"></i>
                            </b-button>
                            </div>
                        </template>
                        <template v-slot:cell(Delete)="row">
                            <div>
                            <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                            <b-button
                                :disabled="!isAdmin"
                                size="sm"
                                variant="danger"
                                @click="deleteWorkstation(row.item)"
                                class="mr-2"
                            >
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </b-button>
                            </div>
                        </template>
                    </b-table>
            </b-col>
        </b-row>
    </b-card>
    <NewWorkstationModal
                      ref="new-workstation"
                      :loop="loop_name"
                      :workstation="selectedWorkstation"
                      :workstation_name="workstationName"/>
  </div>
</template>

<script>
import server from '../../api/server.vue'
import LoopSelector from '../kanban/LoopSelector.vue'
import NewWorkstationModal from './NewWorkstationModal.vue'

export default {
  name: 'LoopOperation',
  props: [],
  data () {
    return {
        workstations: [],
        loop_name: '',
        loop_description: '',
        loop_index: '',
        displayedName: '',
        selectedLoop: '',
        workstationName: '',
        selectedWorkstation: {},
        isAdmin: false,
        fields: [
            { key: 'loop_obj.name', label: 'Boucle', sortable: true },
            { key: 'name', label: 'Nom', sortable: true },
            { key: 'position', label: 'Position', sortable: true },
            'Update',
            'Delete'],
    }
  },
  methods: {
      getLoopInfos() {
          server.getLoopInformation(this.selectedLoop).then((result) => {
              this.loop_name = result.data.name
              this.loop_description = result.data.description
              this.displayedName = result.data.description
              this.loop_index = result.data.index
          })
      },
      showAddWorkstation: function(workstation = {}) {
          this.selectedWorkstation = workstation
          this.workstationName = workstation.name
          this.$refs['new-workstation'].showModal()
      },
      deleteWorkstation (workstation) {
          server.deleteWorkstationItem(this.selectedLoop, workstation.name).then((result) => {
              this.getAllWorkstations()
          })
      },
      getAllWorkstations() {

        server.getWorkstations(this.selectedLoop).then((result) => {
            this.workstations = []
          result.data.forEach(element => {
              this.workstations.push(element)
          });
        })
      },
      onSubmit(evt) {
        evt.preventDefault()
        server.updateGivenLoop({'loop': this.selectedLoop, 'description': this.loop_description, 'name': this.loop_name, 'index': this.loop_index}).then(() => {
            this.makeToast("MaJ réussie !")
        })
      },
      onReset(evt) {
        evt.preventDefault()
        /* Reset our form values */
        this.resetValues()
        /* Trick to reset/clear native browser form validation state */
        this.show = false
        this.$nextTick(() => {
            this.show = true
        })
      },
      getIsAdmin() {
        return window.localStorage.getItem('isAdmin') === 'ADMIN'
      },
  },
  mounted: function () {
      this.selectedLoop = this.$route.params.loop
      this.isAdmin = this.getIsAdmin()
      this.getLoopInfos()
      this.getAllWorkstations()
  },
  components: { LoopSelector, NewWorkstationModal }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/loops/LoopInfosUpdate.vue